function isPlainObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}

function isPrimitiveSignatureValue(value) {
    return value === null || ["string", "number", "boolean"].includes(typeof value);
}

function shouldSortArrayForSignature(key, value) {
    const k = String(key || "").toLowerCase();
    if (k.includes("time") || k.includes("date") || k.includes("range")) {
        return false;
    }
    return value.every(isPrimitiveSignatureValue);
}

function normalizeSignatureValue(value, key = "") {
    if (Array.isArray(value)) {
        const list = value.map((item) => normalizeSignatureValue(item, key));
        if (shouldSortArrayForSignature(key, list)) {
            return list.sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
        }
        return list;
    }
    if (isPlainObject(value)) {
        const result = {};
        Object.keys(value)
            .filter((itemKey) => typeof value[itemKey] !== "undefined")
            .sort()
            .forEach((itemKey) => {
                result[itemKey] = normalizeSignatureValue(value[itemKey], itemKey);
            });
        return result;
    }
    if (typeof value === "undefined") {
        return null;
    }
    return value;
}

export function buildInformationnetSignature(patch, params) {
    return JSON.stringify(normalizeSignatureValue({params, patch}));
}
